module.exports = __webpack_public_path__ + "static/media/add-staff.e3776e62.svg";